import React from 'react';
import { Form } from 'common/components';

const ImportActions = ({
  collapsed,
  t,
  record,
  handleReImportCSV,
  isImporting,
  handleToggleCollapsed,
}) => {
  return (
    <div className="dropdown mr-2">
      <button
        className="btn btn-secondary dropdown-toggle"
        type="button"
        id="dropdownMenuButton"
        data-toggle="dropdown"
        aria-haspopup="true"
        aria-expanded="false"
      >
        {t('common.actions')}
      </button>
      <div className="dropdown-menu p-2" aria-labelledby="dropdownMenuButton">
        <a
          className="btn btn-sm btn-outline-info w-100 my-1"
          href="#expand"
          onClick={(e) => {
            e.preventDefault();
            handleToggleCollapsed();
          }}
        >
          {t(!collapsed ? 'Ocultar detalles' : 'Mostrar detalles')}&nbsp;
          {/* <i
                className={classnames("fa", {
                  "fa-angle-down": collapsed,
                  "fa-angle-up": !collapsed
                })}
              /> */}
        </a>
        <a
          className="btn btn-sm btn-outline-primary w-100 my-1"
          href={record.file}
          target="__blank"
        >
          <i className="fa fa-download" /> {t('import.fields.download')}
        </a>
        <Form.Button
          text={t('import.fields.import')}
          isLoading={isImporting}
          extraClassName={'btn-xs-block w-100 my-1'}
          onClick={(e) => {
            if (!isImporting) {
              e.preventDefault();
              handleReImportCSV(record.file, record.modulo, record.header);
            }
          }}
        />
      </div>
    </div>
  );
};

export default ImportActions;



// WEBPACK FOOTER //
// src/modules/secured/modules/import/components/list/ImportActions.js